<script lang="ts">
  import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
  import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
  import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
  import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
  import background from './background.jpg'
  import button from './button.svg'
  import ashley from './ashley.svg'
  import skyWee from './sky-wee.svg'
</script>

<section class="advisors" id="our-advisors" style="
    --background: url({background});
    --button: url({button});
">
    <div class="container">
        <div class="title">
            Our Advisors
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div>
            <!--
            <div class="peoples">
                <a href="https://x.com/AshleyDCan" target="_blank">
                    <img src="{ashley}" alt="">
                </a>
                <a href="https://x.com/OfficialSkyWee1" target="_blank">
                    <img src="{skyWee}" alt="">
                </a>
            </div>
            -->
            <p class="invite-text">Become our advisor if you have an active community that might be interested in our NFTs</p>
            <div class="text-center">
                <a href="https://forms.gle/Kbx4B6Vq9kqX6shP6" class="button" target="_blank">Become an Advisor</a>
            </div>
        </div>
    </div>
</section>

<style>
    .advisors {
        position: relative;
        padding: 0 0 360px;
        background: var(--background) no-repeat bottom center;
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #FFF0E2 47%, #FFB287 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .peoples {
        display: flex;
        justify-content: center;
    }

    .peoples a {
        display: block;
        margin: 0 45px;
        width: 407px;
    }

    .peoples img {
        max-width: 100%;
        width: 100%;
        height: auto;
    }

    .invite-text {
        color: white;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
        line-height: 150%;
        margin: 100px auto 45px;
        max-width: 650px;
    }

    .button {
        font-size: 40px;
        font-weight: 600;
        text-decoration: none;
        color: white;
        background: var(--button) no-repeat center;
        background-size: contain;
        padding: 38px 75px 32px;
        text-transform: uppercase;
        line-height: 100%;
        user-select: none;
        display: table;
        margin: 0 auto;
        transition: .25s;
    }

    .button:hover {
        transform: scale(1.05);
    }

    @media(max-width: 1750px) {
        .peoples a {
            width: 370px;
        }
    }

    @media(max-width: 1520px) {
        .peoples a {
            width: 350px;
        }
    }

    @media(max-width: 1400px) {
        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .peoples a {
            width: 300px;
            margin: 0 30px;
        }

        .button {
            font-size: 30px;
        }
    }

    @media(max-width: 1200px) {
        .title {
            font-size: 60px;
        }

        .button {
            font-size: 26px;
            padding: 28px 50px 24px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }

        .advisors {
            padding: 0 0 200px;
            background-size: cover;
        }

        .invite-text {
            font-size: 18px;
            max-width: 550px;
            margin: 70px auto 35px;
        }

        .button {
            font-size: 20px;
            padding: 20px 36px 16px;
        }
    }

    @media(max-width: 767px) {
        .advisors {
            padding: 0 0 100px;
            background-size: contain;
        }

        .peoples {
            padding: 0;
        }

        .peoples a {
            width: 100%;
            margin: 0 12px;
        }

        .invite-text {
            font-size: 16px;
            margin: 40px auto 20px;
        }

        .button {
            font-size: 26px;
            padding: 28px 30px 24px;
        }
    }
</style>
